import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';

const URL = '/v2/video-moderation';

class VideoModerationService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<unknown>> {
    return axios.get(URL, config);
  }

  static patch(data: Record<string, unknown> & { id: number }, config?: AxiosRequestConfig): Promise<DataResponse<unknown>> {
    return axios.patch(`${URL}/${data.id}`, data, config);
  }
}

export { VideoModerationService };
